import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Spinner } from "react-bootstrap";
import PrivateApi from "../../../../services/PrivateApiService";
import Validator from "../../../../services/Validator";
import { useEffect, useState } from "react";
import Steper from "../../../shared/Steper";
import EmployeeMask from "../../../form_masks/share/EmployeeMask";
import AddressMask from "../../../form_masks/anlage/new/AddressMask";
import AnlageDataMask from "../../../form_masks/anlage/new/AnlageDataMask";
import RegisterMask from "../../../form_masks/anlage/new/RegisterMask";
import SummaryMask from "../../../form_masks/anlage/new/SummaryMask";
import DoneMask from "../../../form_masks/share/DoneMask";
import ErrorMask from "../../../form_masks/share/EmployeeMask";
import { useAuthState } from "../../../../context/AuthContext";
import { useQueryClient } from "react-query";

const HwNewAnlageModal = ({show, setShow, building}) => {

    // ! -------------
    // ! Global vars |
    // ! -------------
    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const { contactPerson } = useAuthState();
    const VALIDATOR = new Validator();
    const [apiError, setApiError] = useState("");

    // * Mask vars
    const [isLoading, setIsLoading] = useState(false);
    const [places, setPlaces] = useState([])
    const [step, setStep] = useState("contactPerson");
    const [stepIndicator] = useState([
        {id: "step1", key:"contactPerson", title:"Kontaktperson", number: 1},
        {id: "step2", key:"address", title:"Adresse", number: 2},
        {id: "step3", key:"anlageData", title:"Anlagendaten", number: 3},
        {id: "step4", key:"register", title:"Anmeldedaten", number: 4},
        {id: "step5", key:"summary", title:"Ihre Zusammenfassung", number: 5},
    ]);
    const defaultData = {
        contact: contactPerson,
        building: building,

        x_anlagenverwendung: "",
        x_anlagenverwendung_detail: "",
        bestand: "",
        country_id: building.country_id.length > 0 ? building.country_id[0].toString() : "12",
        state_id: building.state_id.length > 0 ? building.state_id[0].toString() : "",
        zip: building.zip,
        city: building.city,
        street: building.street.replace(/\s*\d.*$/, '').trim(),
        houseNr: building.street.match(/\d+/) ? building.street.match(/\d+/)[0] : "",
        stiege: "",
        top: "",
        leerstand: false,

        energyForm: "",
        x_is_smartmeter_01: false,
        x_is_smartmeter_02: false,
        secondZaehler: false,
        zaehlerLocation: "",
        x_zaehlernummer_01: "",
        x_zaehlernummer_02: "",
        x_zaehlpunktnummer_01: "",
        x_zaehlpunktnummer_02: "",
        zaehlerstand1: "",
        zaehlerstand2: "",

        register: true,
        registerDate: "",
        useMtu: false,
        mtuName: "",
        mtuDirect: false,
        mtuPaysOverTransfer: false,
        mtuAccountOwner: "",
        mtuIban: "",
    }
    const [data, setData] = useState(defaultData);
    const [formError, setFormError] = useState({});


    // ! ---------
    // ! Effects |
    // ! ---------
    // * Effect on closing and reapearing of modal
    useEffect(() => {
        if (show && step === "done") {
            setData(defaultData);
            setStep(stepIndicator[0].key);
        }
    }, [show])


    // ! -----------
    // ! Functions |
    // ! -----------
    // * Handler for back button
    const backBtnHandler = () => {
        const index = stepIndicator.findIndex((i) => i.key === step);
        if (index > 0) {
            setStep(stepIndicator[index -1].key);
        }
    }

    // * Handler for next button
    const nextBtnHandler = () => {
        var tmpError = {};

        // checks
        if (step === "contactPerson") {
            if (data.contactPerson === 0) tmpError.contactPerson = true;
        }
        if (step === "address") {
            if (data.x_anlagenverwendung === "") tmpError.x_anlagenverwendung = true;
            if (data.country_id === "") tmpError.country_id = true;
            if (data.country_id === "12" && data.state_id === "") tmpError.state_id = true;
            if (!VALIDATOR.isValidZip(data.country_id, data.state_id, data.zip)) tmpError.zip = true;
            if (places.length > 0) {
                if (!places.includes(data.city) || data.city === "") tmpError.city = true;
            } else {
                if (data.city === "") tmpError.city = true;
            }
            if (!VALIDATOR.StringLength(3, 80, data.street)) tmpError.street = true;
            if (data.houseNr === "") tmpError.houseNr = true;
            if (data.x_anlagenverwendung === "Wohnung" && data.top === "") tmpError.top = true;
            if (data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" && data.x_anlagenverwendung_detail === "") tmpError.x_anlagenverwendung_detail = true;
            
            // fix leerstand for "Allgemeine Liegenschaftsteile"
            if (data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile") {
                setData(prev => ({...prev, leerstand: false}));
            }
        }
        if (step === "anlageData") {
            if (!VALIDATOR.isValidEnergyForm(data.energyForm)) tmpError.energyForm = true;
            if (data.x_zaehlernummer_01 === undefined || data.x_zaehlernummer_01.length < 6) tmpError.x_zaehlernummer_01 = true;
            if (
                data.secondZaehler === true && 
                (!data.x_zaehlernummer_02 || data.x_zaehlernummer_02.length < 6)
            ) tmpError.x_zaehlernummer_02 = true;
            if (
                data.x_zaehlpunktnummer_01 &&
                data.x_zaehlpunktnummer_01 !== "" && 
                !VALIDATOR.isFormatedZaehlpunknummerValid(data.x_zaehlpunktnummer_01)) tmpError.x_zaehlpunktnummer_01 = true;
            if (
                data.secondZaehler && data.secondZaehler === true &&
                data.x_zaehlpunktnummer_02 &&
                data.x_zaehlpunktnummer_02 !== "" && !VALIDATOR.isFormatedZaehlpunknummerValid(data.x_zaehlpunktnummer_02)
            ) tmpError.x_zaehlpunktnummer_02 = true;
        }
        if (step === "register") {
            if (data.register === true && !VALIDATOR.dateValid(data.registerDate)) tmpError.registerDate = true;
            if (data.register === true && data.x_is_smartmeter_01 === false && !VALIDATOR.IsZaehlerstand(data.zaehlerstand1)) tmpError.zaehlerstand1 = true;
            if (data.register === true && data.zaehlerstand1 !== "" && !VALIDATOR.IsZaehlerstand(data.zaehlerstand1)) tmpError.zaehlerstand1 = true;
            if (
                data.register === true &&
                data.x_is_smartmeter_01 === false &&
                data.secondZaehler === true &&
                !VALIDATOR.IsZaehlerstand(data.zaehlerstand2)
            ) tmpError.zaehlerstand2 = true;
            if (
                data.register === true &&
                data.x_is_smartmeter_01 === false &&
                data.secondZaehler === true &&
                !VALIDATOR.IsZaehlerstand(data.zaehlerstand2)
            ) tmpError.zaehlerstand2 = true;
            
            if (data.useMtu === true) {
                if (data.mtuName.length < 4) tmpError.mtuName = true;
                if (data.mtuDirect === true && data.mtuPaysOverTransfer === false && data.mtuAccountOwner.length < 4) tmpError.mtuAccountOwner = true;
                if (data.mtuDirect === true && data.mtuPaysOverTransfer === false && VALIDATOR.ibanValid(data.mtuIban.replace(/\s+/g, '')) === false) tmpError.mtuIban = true;
            }
        }
        if (step === "summary") {
            return sendData();
        }

        // if tmpError has errors return them
        if (Object.keys(tmpError).length > 0) {
            return setFormError(tmpError);
        }

        // go to next step
        const index = stepIndicator.findIndex((i) => i.key === step);
        setStep(stepIndicator[index + 1].key);
    }

    // * Send data to API
    const sendData = () => {
        setIsLoading(true);
        API.hw_Anlagen_new(data)
            .then(() => {
                queryClient.invalidateQueries("GET_ALL_BUILDING_INFO_QUERY");
                setStep("done");
            })
            .catch(err => {
                if (err.response.data.detail && err.response.data.detail !== "") {
                    setApiError(err.response.data.detail)
                } else {
                    setApiError("Unbekanter Fehler aufgetreten.")
                }
                setStep("error");
            })
            .finally(() => setIsLoading(false))
    }

    // * Add another button handler
    const addAnotherBtnHandler = () => {
        setData(defaultData);
        setStep(stepIndicator[1].key);
    }



    return (
        <Modal show={show} onHide={() => setShow(false)} size="xl" backdrop="static">
            <ModalHeader closeButton>
                <ModalTitle>Neue Anlage hinzufügen</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Steper step={step} data={stepIndicator} />
                {
                    step === "contactPerson" ?
                        <EmployeeMask formData={data} setFormData={setData} formError={formError} setFormError={setFormError} nextHandler={nextBtnHandler} /> :
                    step === "address" ?
                        <AddressMask data={data} setData={setData} formError={formError} setFormError={setFormError} setPlaces={setPlaces} hwMode /> :
                    step === "anlageData" ? 
                        <AnlageDataMask data={data} setData={setData} formError={formError} setFormError={setFormError} hwMode /> :
                    step === "register" ?
                        <RegisterMask data={data} setData={setData} formError={formError} setFormError={setFormError} hwMode /> :
                    step === "summary" ?
                        <SummaryMask data={data} setStep={setStep} hwMode /> :
                    step === "done" ?
                        <DoneMask message={"Vielen Dank! Wir haben die Daten zur Anlage erhalten und werden Sie in Kürze bearbeiten."} /> :
                    step === "error" ?
                        <ErrorMask error={apiError} /> :
                    null
                }
            </ModalBody>
            <ModalFooter>
                <div hidden={step === "done" || step === "error"} className="text-end">
                    <Button
                        className="me-2"
                        variant="warning"
                        hidden={stepIndicator[0].key === step}
                        onClick={backBtnHandler}
                    >Zurück</Button>
                    <Button
                        hidden={step === "contactPerson"}
                        variant="energo"
                        disabled={isLoading}
                        onClick={nextBtnHandler}
                    >
                        {isLoading ?
                            <Spinner animation="border" /> :
                        step === "summary" ?
                            "Absenden" :
                            "Weiter"
                        }
                    </Button>
                </div>
                <div hidden={step !== "done"} className="text-end">
                    <Button onClick={addAnotherBtnHandler} variant="energo">
                        Neue Anlage hinzufügen
                    </Button>
                </div>
                <div hidden={step !== "error"} className="text-end">
                    <Button 
                        className="me-2"
                        variant="warning"
                        onClick={() => setStep("summary")}
                    >
                        Zurück
                    </Button>
                    <Button 
                        disabled={isLoading}
                        onClick={() => sendData()} 
                        variant="energo"
                    >
                        {isLoading ?
                            <Spinner animation="border" /> :
                            "Erneut versuchen"
                        }
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default HwNewAnlageModal;